// Function to calculate distance (simplified Euclidean distance - consider spherical for accuracy)
export function calculateDistanceSquared(p1, p2) {
  // p1 = { lat: number, lng: number } (clicked point)
  // p2 = { lat: number, lng: number } (point from trackPoints)
  const dx = p1.lng - p2.lng;
  const dy = p1.lat - p2.lat;
  // Using squared distance avoids Math.sqrt, faster for comparison
  return dx * dx + dy * dy;
}
